module.exports = __webpack_public_path__ + "img/6.fb005a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/6.png
// module id = UON1
// module chunks = 1